// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"125":"942b682495e87829","897":"22f55d4aeb5ae2ea"}[chunkId] + ".js";
};